import { usePageViewTracker } from "@/hooks/usePageViewTracker";

export const PageViewTracker = () => {
  usePageViewTracker();
  return null;
};
